/**
 * @Description: 下载导出
 */
import { fileDownload } from "@/ask/axios";
/**
 * @export
 * @param {*} url  下载地址  ---接口地址
 * @param {*} fileName  下载的命名
 */
export function downloadFile(url, fileName) {
  console.log(url)
  let mb = myBrowser();
  if ('IE' == mb) {
    getBlob(url).then(blob => {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    });
  } else {
    var request = new XMLHttpRequest();
    request.responseType = "blob";
    request.open("GET", url);
    request.onload = function () {
      var url = window.URL.createObjectURL(this.response);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = fileName
      a.click();
    }
    request.send();
  }
}
function getBlob(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}
function myBrowser() {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return "IE";  // 因为ie10-ie11的版本问题，不再支持document.all判断，所以ie判断函数要重新写了
  }
}


/**
 * @description:下载导出文件流
//  * @param { string } method  请求 api 方法类型
//  * @param { string } url  请求 api 地址
 * @param { object } vm this
 * @param { object } params  请求 api 传递的参数
 * @param { string } fileName 导出文件名称, 需要加后缀名
*/
export function fileSteamDownload(vm, params, fileName) {
  fileDownload('get', vm.$api04 + '/File/api/FileHandle/Download', params).then((res) => {
    // 把后台传过来的文件流转化成blob url路径下载
    const hrefUrl = window.URL.createObjectURL(
      new Blob([res.data], {
        type: "application/vnd.opencmlformats-officedocument.spreadsheetml.sheet",
      })
    );
    // 创建一个a标签下载文件
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = hrefUrl;
    // 设置文件名称、后缀名
    link.download = decodeURIComponent(fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // 释放内存
    window.URL.revokeObjectURL(hrefUrl);
  });
}

/**
 * @param type 跳转类型 1：本页面跳转；2：新开页面跳转； 3：下载
 * @param href 跳转链接
 * @param fileName 下载时文件名
 * @description 解决浏览器执行不了window.open和window.location.href的跳转
 */
export function browserHref(href, type = 1, fileName = "") {
  // 创建一个a标签下载文件
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = href;
  // 设置a标签target属性
  if (type == 2) {
    link.setAttribute("target", "_blank");
  }
  // 设置文件名称、后缀名
  if (type == 3) {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


// WEBPACK FOOTER //
// ./src/utils/download.js